import(/* webpackMode: "eager" */ "/vercel/path0/src/assets/default-landing-header-image.webp");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/features/gateway-page/ui/GatewayPage.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageLayout"] */ "/vercel/path0/src/features/shared/layout/page/PageLayout.tsx");
